import { auth } from '@dashai/lib/firebase';

/**
 * Track a login/logout event for admin dashboard analytics.
 * Fire-and-forget — errors are logged but never block the UI.
 *
 * Calls `dashaiAdminTrackLogin` on Firebase. The endpoint takes the
 * caller's uid from the Firebase ID token (server-injected), so we
 * don't pass `userId` in the body. `dashaiAdminTrackLogin` is
 * deployed on dev/stg/prod and `VITE_FIREBASE_FUNCTIONS_URL` is
 * committed in apps/web/.env.development.
 *
 * Can optionally receive an idToken directly (useful when called from
 * authSlice where Firebase auth.currentUser may not be set yet).
 */
export async function trackLogin(params: {
  eventType: 'login' | 'logout';
  authMethod?: 'email' | 'google';
  idClient?: string;
  idToken?: string;
  userId?: string;
}) {
  try {
    const idToken = params.idToken || (await auth.currentUser?.getIdToken());
    if (!idToken) return;

    const fbBase = import.meta.env.VITE_FIREBASE_FUNCTIONS_URL as string | undefined;
    if (!fbBase) {
      console.error(
        '[trackLogin] VITE_FIREBASE_FUNCTIONS_URL is not set — cannot reach dashaiAdminTrackLogin.',
      );
      return;
    }
    await fetch(`${fbBase.replace(/\/+$/, '')}/dashaiAdminTrackLogin`, {
      method: 'POST',
      headers: { Authorization: `Bearer ${idToken}`, 'Content-Type': 'application/json' },
      body: JSON.stringify({
        eventType: params.eventType,
        authMethod: params.authMethod,
        idClient: params.idClient,
      }),
    });
  } catch (err) {
    console.error('[trackLogin] Error:', err);
  }
}
